var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3486 8.66895C17.3486 13.4062 13.4062 17.3379 8.66895 17.3379C3.94238 17.3379 0 13.4062 0 8.66895C0 3.93164 3.93164 0 8.6582 0C13.3955 0 17.3486 3.93164 17.3486 8.66895ZM8.78711 5.73633C8.78711 5.94043 8.88379 6.13379 9.00195 6.2627L9.92578 7.17578L10.957 7.99219L8.98047 7.91699H4.91992C4.47949 7.91699 4.16797 8.22852 4.16797 8.6582C4.16797 9.08789 4.47949 9.39941 4.91992 9.39941H8.98047L10.9678 9.32422L9.92578 10.1514L9.00195 11.0537C8.87305 11.1826 8.78711 11.376 8.78711 11.5801C8.78711 11.9883 9.09863 12.3105 9.50684 12.3105C9.72168 12.3105 9.89355 12.2354 10.0225 12.1064L12.8799 9.24902C13.0732 9.05566 13.1699 8.88379 13.1699 8.6582C13.1699 8.44336 13.084 8.28223 12.8799 8.07812L10.0225 5.20996C9.89355 5.08105 9.72168 5.0166 9.50684 5.0166C9.09863 5.0166 8.78711 5.32812 8.78711 5.73633Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledArrowIcon);
export default __webpack_public_path__ + "static/media/filled_arrow_icon.6d05d8b4b85e79fe8198d976ef525686.svg";
export { ForwardRef as ReactComponent };